import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { LeadForm } from "../components/LeadForm";
import { Crown } from "lucide-react";

export default function Party() {
  const [platters, setPlatters] = useState([]);
  useEffect(() => { api.get("/products", { params: { category: "platters" } }).then((r) => setPlatters(r.data)); }, []);
  return (
    <div data-testid="party-page">
      <section className="bg-navy hero-motif py-16 text-center">
        <Crown className="mx-auto text-gold mb-3" size={32} />
        <div className="overline text-gold">Plan a party?</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-cream mt-2">Party Platters & Group Orders</h1>
        <p className="text-cream/75 mt-4 max-w-xl mx-auto px-4">Feed the whole gathering with our generous platters, or tell us your requirement for a custom group order.</p>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <h2 className="font-serif text-3xl text-navy mb-6">Our Platters</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">{platters.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}</div>
      </section>
      <section className="max-w-2xl mx-auto px-4 sm:px-6 pb-14">
        <div className="bg-white rounded-2xl border border-black/5 p-7">
          <LeadForm source="Party Orders" title="Plan Your Party" cta="Submit Requirement"
            fields={["name", "phone", "email", "event_date", "guests", "requirement"]} />
        </div>
      </section>
    </div>
  );
}
